import { ColumnTable } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PeriodItem } from '../../api/partnership';

const prefix = 'tariffAndTuition.partnerships';

export function usePartnershipColumns() {
  const { t } = useTranslation();

  const columns: ColumnTable<PeriodItem>[] = useMemo(
    () => [
      {
        columnName: 'name',
        headerText: t(`${prefix}.period`),
        thClassName: 'text-left',
        tdClassName: 'text-left',
        cellFormat: ({ row }) => (
          <span className="fw-bold">
            {row.name} ({row.code})
          </span>
        ),
      },
    ],
    [t],
  );

  return columns;
}
